import React, { useState, CSSProperties, useEffect } from "react";
import { sendVisitLog } from "helpers/visitLogger";
import salesTrackify from "../../../assets/images/SalesTrackify.png"
import { colors } from "styles/colors";

const Cookies = require("js-cookie");

const CookiesDemo = () => {
    const [isCookieSet, setCookie] = useState<boolean>(!!Cookies.get("cookieConsent"));
    const [showPopup, setShowPopup] = useState<boolean>(false);

    // Check if visitor is a bot/crawler
    const isBot = () => {
        const botPatterns = /bot|crawler|spider|scraper|curl|wget|googlebot|bingbot|yandexbot|slurp|duckduckbot|baiduspider|sogou|exabot|facebookexternalhit|reactsnap/i;
        return botPatterns.test(navigator.userAgent);
    };

    useEffect(() => {
        // Don't show cookie popup to bots
        if (isBot()) {
            setCookie(true);
            return;
        }

        // Show popup only after page content is fully loaded
        if (!isCookieSet) {
            const currentPage = window.location.href;
            Cookies.set("lastPageVisited", currentPage, { expires: 1 });
            
            // Delay showing popup until DOM is ready and page has rendered
            const showPopupTimeout = setTimeout(() => {
                setShowPopup(true);
            }, 2000); // Wait 2 seconds for page to render

            return () => clearTimeout(showPopupTimeout);
        }
    }, [isCookieSet]);




    const handleAcceptCookies = async () => {
        try {
            const res = await fetch("https://ipapi.co/json/");
            const data = await res.json();

            const country = data.country_name || "Unknown";
            const state = data.region || "Unknown";
            const city = data.city || "Unknown";

            // Save country + state
            localStorage.setItem("userCountry", country);
            localStorage.setItem("userState", state);
            localStorage.setItem("userCity", city);

            Cookies.set("userCountry", country, { expires: 7 });
            Cookies.set("userState", state, { expires: 7 });
            Cookies.set("userCity", city, { expires: 7 });

            const enhancedGeoData = {
                country: country,
                state: state,       // FIXED (use region)
                city: city,
                postalCode: data.postal,
                latitude: data.latitude,
                longitude: data.longitude,
                IPv4: data.ip
            };

            Cookies.set("geoData", JSON.stringify(enhancedGeoData), { expires: 7 });
            localStorage.setItem("geoData", JSON.stringify(enhancedGeoData));

        } catch (err) {
            console.log("Country fetch failed", err);
        }

        Cookies.set("cookieConsent", "true", { expires: 1 });
        Cookies.set("lastPageVisited", window.location.href, { expires: 1 });

        await sendVisitLog(window.location.href);

        setCookie(true);
        setShowPopup(false); // Close popup without reload
    };


    const handleRejectCookies = () => {
        Cookies.set("cookieConsent", "false", { expires: 1 });
        sendVisitLog(window.location.href);
        setCookie(true);
        setShowPopup(false); // Close popup immediately
    };

    return (
        <>
            {showPopup && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <div style={styles.accentBar} />
                        <div style={styles.header}>
                            <div style={styles.brandMark}>
                                <img src={salesTrackify} alt="SalesTrackify" height="24" />
                            </div>
                            <span style={styles.badge}>Privacy notice</span>
                        </div>

                        <h2 style={styles.title}>Cookie preferences</h2>

                        <p style={styles.text}>
                            We use cookies to keep the site reliable, understand visits, and improve your experience.
                            You can accept all cookies or continue with essential cookies only.
                        </p>

                        <div style={styles.actions}>
                            <button style={styles.acceptButton} onClick={handleAcceptCookies}>
                                Accept All
                            </button>
                            <button style={styles.rejectButton} onClick={handleRejectCookies}>
                                Reject All
                            </button>
                        </div>
                        {/* 
                        <button style={styles.linkButton}>Cookie Preferences</button> */}
                    </div>
                </div>
            )}
        </>
    );
};

const styles: { [key: string]: CSSProperties } = {
    overlay: {
        position: "fixed",
        right: "18px",
        bottom: "18px",
        width: "min(410px, calc(100vw - 28px))",
        display: "flex",
        zIndex: 10000,
    },
    modal: {
        position: "relative",
        overflow: "hidden",
        backgroundColor: "rgba(255, 255, 255, 0.98)",
        padding: "18px 18px 16px",
        borderRadius: "14px",
        width: "100%",
        boxShadow: "0 18px 45px rgba(15, 23, 42, 0.18)",
        textAlign: "left",
        border: "1px solid rgba(15, 23, 42, 0.10)",
        animation: "fadeIn 0.3s ease-in-out",
        fontSize: "14px",
        lineHeight: "1.55",
        color: "#334155",
    },
    accentBar: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "4px",
        background: `linear-gradient(90deg, ${colors.primary.teal}, #24347D)`,
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        marginBottom: "14px",
    },
    brandMark: {
        display: "flex",
        alignItems: "center",
        minWidth: 0,
    },
    badge: {
        flexShrink: 0,
        borderRadius: "999px",
        backgroundColor: "rgba(38, 162, 171, 0.10)",
        color: colors.primary.teal,
        fontSize: "11px",
        fontWeight: 700,
        padding: "5px 9px",
        letterSpacing: "0.2px",
    },
    title: {
        fontSize: "18px",
        fontWeight: 800,
        marginBottom: "8px",
        color: "#111827",
        marginTop: 0,
        lineHeight: "1.25",
    },
    text: {
        fontSize: "13px",
        lineHeight: "1.6",
        marginBottom: 0,
        color: "#475569",
    },
    actions: {
        display: "flex",
        gap: "10px",
        marginBottom: 0,
        marginTop: "16px"
    },
    acceptButton: {
        backgroundColor: colors.primary.teal,
        color: "white",
        border: "none",
        padding: "10px 16px",
        borderRadius: "10px",
        fontWeight: 800,
        cursor: "pointer",
        flex: "1 1 0",
        fontSize: "13px",
        boxShadow: "0 8px 16px rgba(38, 162, 171, 0.24)",
    },
    rejectButton: {
        backgroundColor: "#f8fafc",
        color: "#334155",
        border: "1px solid #cbd5e1",
        padding: "10px 16px",
        borderRadius: "10px",
        fontWeight: 800,
        cursor: "pointer",
        flex: "1 1 0",
        fontSize: "13px",
    },
    linkButton: {
        background: "none",
        border: "none",
        color: "#888",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "14px",
        alignSelf: "flex-start",
    },
};

export default CookiesDemo;
